/*! For license information please see index.js.LICENSE.txt */
(() => {
  "use strict";

  var e = {
    296: (e, r, t) => {
      var n = t(497),
          o = Symbol.for("react.element"),
          a = Symbol.for("react.fragment"),
          i = Object.prototype.hasOwnProperty,
          l = n.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner,
          c = {
        key: !0,
        ref: !0,
        __self: !0,
        __source: !0
      };

      function s(e, r, t) {
        var n,
            a = {},
            s = null,
            u = null;

        for (n in void 0 !== t && (s = "" + t), void 0 !== r.key && (s = "" + r.key), void 0 !== r.ref && (u = r.ref), r) i.call(r, n) && !c.hasOwnProperty(n) && (a[n] = r[n]);

        if (e && e.defaultProps) for (n in r = e.defaultProps) void 0 === a[n] && (a[n] = r[n]);
        return {
          $$typeof: o,
          type: e,
          key: s,
          ref: u,
          props: a,
          _owner: l.current
        };
      }

      r.Fragment = a, r.jsx = s, r.jsxs = s;
    },
    261: (e, r, t) => {
      e.exports = t(296);
    },
    497: e => {
      e.exports = require("react");
    }
  },
      r = {};

  function t(n) {
    var o = r[n];
    if (void 0 !== o) return o.exports;
    var a = r[n] = {
      exports: {}
    };
    return e[n](a, a.exports, t), a.exports;
  }

  t.d = (e, r) => {
    for (var n in r) t.o(r, n) && !t.o(e, n) && Object.defineProperty(e, n, {
      enumerable: !0,
      get: r[n]
    });
  }, t.o = (e, r) => Object.prototype.hasOwnProperty.call(e, r), t.r = e => {
    "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
      value: "Module"
    }), Object.defineProperty(e, "__esModule", {
      value: !0
    });
  };
  var n = {};
  (() => {
    function e(r) {
      var t,
          n,
          o = "";
      if ("string" == typeof r || "number" == typeof r) o += r;else if ("object" == typeof r) if (Array.isArray(r)) {
        var a = r.length;

        for (t = 0; t < a; t++) r[t] && (n = e(r[t])) && (o && (o += " "), o += n);
      } else for (n in r) r[n] && (o && (o += " "), o += n);
      return o;
    }

    t.r(n), t.d(n, {
      CarvanaHeader: () => re,
      default: () => te,
      getHeaderManifest: () => J
    });

    const r = function () {
      for (var r, t, n = 0, o = "", a = arguments.length; n < a; n++) (r = arguments[n]) && (t = e(r)) && (o && (o += " "), o += t);

      return o;
    },
          o = {
      "logo-wrapper": "t87CFilO95VDki9K5bUd",
      "logo-separator": "NAo3F8KgkyH1iKS3lvmf",
      "desktop-logo": "NbqcwC8B24beWQ2XPVXu",
      "mobile-logo": "_GflwG_syAFuHeJ087j9"
    };

    var a = t(261),
        i = function (e) {
      return "".concat("https://assets.fastly.carvana.io", "/partner-header-logos-assets/combo-").concat(e, ".svg");
    };

    function l(e) {
      var t = e.className,
          n = void 0 === t ? "" : t,
          l = e.partnerVanityUrlName,
          c = void 0 === l ? "notused" : l,
          s = e.shouldHidePartnerHeaderBanner,
          u = void 0 === s || s,
          f = e.onClick,
          d = "notused" === c || u ? "carvana" : c.toLowerCase(),
          v = i("desktop-".concat(d)),
          p = i("mobile-".concat(d));
      return (0, a.jsx)("div", {
        className: r(o["logo-wrapper"], n),
        children: (0, a.jsxs)("a", {
          href: "/",
          target: "_self",
          title: "Carvana",
          onClick: f,
          children: [(0, a.jsx)("div", {
            className: o["desktop-logo"],
            children: (0, a.jsx)("img", {
              src: v,
              alt: "Carvana"
            })
          }), (0, a.jsx)("div", {
            className: o["mobile-logo"],
            children: (0, a.jsx)("img", {
              src: p,
              alt: "Carvana"
            })
          })]
        })
      });
    }

    const c = {
      "header-wrapper": "_9flirVCTysoofC5vp5Qg",
      "nav-bar": "jymWWXeZp1wEuxcZ3bpi",
      "favorites-skeleton": "KlXi8JrdX_l4IcUkLEMY",
      account: "Apq_yfMQ7lVg40yQyTrD",
      break: "vsG6R9Ew8B6I8suLxnPA"
    };

    function s(e) {
      var r,
          t,
          n = "";
      if ("string" == typeof e || "number" == typeof e) n += e;else if ("object" == typeof e) if (Array.isArray(e)) for (r = 0; r < e.length; r++) e[r] && (t = s(e[r])) && (n && (n += " "), n += t);else for (r in e) e[r] && (n && (n += " "), n += r);
      return n;
    }

    const u = function () {
      for (var e, r, t = 0, n = ""; t < arguments.length;) (e = arguments[t++]) && (r = s(e)) && (n && (n += " "), n += r);

      return n;
    },
          f = function (e) {
      var r = e.href,
          t = e.route,
          n = e.children,
          o = e.onClick,
          i = r === t || (t || "").startsWith(r);
      return (0, a.jsx)("a", {
        href: r,
        className: u("o_3CXzu5ryIXwGUee3r9", i ? "E3JTBh0baGQctJbBGZ5E" : ""),
        onClick: o,
        children: n
      });
    };

    var d,
        v = t(497);

    function p() {
      return p = Object.assign ? Object.assign.bind() : function (e) {
        for (var r = 1; r < arguments.length; r++) {
          var t = arguments[r];

          for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        }

        return e;
      }, p.apply(this, arguments);
    }

    const y = function (e) {
      return v.createElement("svg", p({
        xmlns: "http://www.w3.org/2000/svg",
        width: 17,
        height: 16,
        fill: "none"
      }, e), d || (d = v.createElement("path", {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M7.705 2.667a4.667 4.667 0 1 0 3.237 8.027.7.7 0 0 1 .124-.123 4.667 4.667 0 0 0-3.361-7.904m4.688 8.411a6 6 0 1 0-.943.943l2.45 2.45a.667.667 0 1 0 .943-.943z",
        clipRule: "evenodd"
      })));
    };

    function m(e) {
      var r = e.route,
          t = e.className,
          n = void 0 === t ? "" : t;
      return (0, a.jsxs)("div", {
        className: n,
        children: [(0, a.jsxs)(f, {
          href: "/cars",
          route: r,
          children: [(0, a.jsx)(y, {}), (0, a.jsxs)("span", {
            children: ["Search", (0, a.jsx)("span", {
              className: "hide-mobile",
              children: " Cars"
            })]
          })]
        }), (0, a.jsx)(f, {
          href: "/sell-my-car",
          route: r,
          children: "Sell/Trade"
        }), (0, a.jsx)(f, {
          href: "/financing",
          route: r,
          children: "Financing"
        })]
      });
    }

    var h;

    function g() {
      return g = Object.assign ? Object.assign.bind() : function (e) {
        for (var r = 1; r < arguments.length; r++) {
          var t = arguments[r];

          for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        }

        return e;
      }, g.apply(this, arguments);
    }

    const b = function (e) {
      return v.createElement("svg", g({
        xmlns: "http://www.w3.org/2000/svg",
        width: 24,
        height: 24,
        fill: "none"
      }, e), h || (h = v.createElement("path", {
        fill: "#0D375E",
        d: "M3 6a1 1 0 0 1 1-1h16a1 1 0 1 1 0 2H4a1 1 0 0 1-1-1m0 6a1 1 0 0 1 1-1h16a1 1 0 1 1 0 2H4a1 1 0 0 1-1-1m0 6a1 1 0 0 1 1-1h16a1 1 0 1 1 0 2H4a1 1 0 0 1-1-1"
      })));
    };

    var w;

    function j() {
      return j = Object.assign ? Object.assign.bind() : function (e) {
        for (var r = 1; r < arguments.length; r++) {
          var t = arguments[r];

          for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        }

        return e;
      }, j.apply(this, arguments);
    }

    const k = function (e) {
      return v.createElement("svg", j({
        xmlns: "http://www.w3.org/2000/svg",
        width: 16,
        height: 16,
        fill: "none",
        viewBox: "0 0 20 20"
      }, e), w || (w = v.createElement("path", {
        fill: "#475569",
        d: "M10 2.5a5 5 0 0 0-3.093 8.929 8.33 8.33 0 0 0-4.957 5.58.833.833 0 0 0 1.61.432 6.667 6.667 0 0 1 12.88 0 .833.833 0 1 0 1.61-.431 8.33 8.33 0 0 0-4.957-5.581A5 5 0 0 0 10 2.5m-3.333 5a3.333 3.333 0 1 1 6.666 0 3.333 3.333 0 0 1-6.666 0"
      })));
    },
          O = {
      "logged-in-initials": "kTm85hB1uxtkM8LqHa1Z",
      "logged-out-user": "dHX5WzitVCJeVx4UZhjg",
      "logged-out-user-svg": "QQpTQ9VfEAJvNLaV87Aj",
      lg: "Ir_ajam7OSAPVFu_ExYJ"
    };

    var S = function () {
      return (0, a.jsx)(k, {
        "data-testid": "user-icon"
      });
    },
        x = (0, v.memo)(function (e) {
      var t = e.size,
          n = e.isLoggedIn,
          o = e.first,
          i = void 0 === o ? "" : o,
          l = e.last,
          c = void 0 === l ? "" : l,
          s = i && c,
          u = i && (null == i ? void 0 : i.charAt(0)) || "",
          f = c && (null == c ? void 0 : c.charAt(0)) || "";
      return n ? (0, a.jsx)("div", {
        className: r(O["logged-in-initials"], O[t]),
        "data-testid": "user-initials",
        children: s ? (0, a.jsxs)(a.Fragment, {
          children: [u, f]
        }) : (0, a.jsx)(S, {})
      }) : (0, a.jsx)("div", {
        className: O["logged-out-user"],
        children: (0, a.jsx)("div", {
          className: O["logged-out-user-svg"],
          children: (0, a.jsx)(S, {})
        })
      });
    }),
        A = function (e) {
      var r = e.children,
          t = e.onClick,
          n = function (e) {
        e.key && "Enter" !== e.key || null == t || t();
      };

      return (0, a.jsx)("div", {
        className: "ELa1rpWc9ldu6dzV9cJy",
        onClick: n,
        onKeyDown: n,
        role: "button",
        tabIndex: 0,
        "data-testid": "hamburgler",
        children: r
      });
    },
        _ = function (e) {
      var r = e.isLoggedIn,
          t = e.first,
          n = e.last,
          o = e.onClick;
      return (0, a.jsxs)(A, {
        onClick: o,
        children: [(0, a.jsx)(x, {
          size: "sm",
          isLoggedIn: r,
          first: t,
          last: n
        }), (0, a.jsx)(b, {
          "data-testid": "hamburger-icon"
        })]
      });
    };

    function I(e) {
      this.message = e;
    }

    I.prototype = new Error(), I.prototype.name = "InvalidCharacterError";

    var E = "undefined" != typeof window && window.atob && window.atob.bind(window) || function (e) {
      var r = String(e).replace(/=+$/, "");
      if (r.length % 4 == 1) throw new I("'atob' failed: The string to be decoded is not correctly encoded.");

      for (var t, n, o = 0, a = 0, i = ""; n = r.charAt(a++); ~n && (t = o % 4 ? 64 * t + n : n, o++ % 4) ? i += String.fromCharCode(255 & t >> (-2 * o & 6)) : 0) n = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=".indexOf(n);

      return i;
    };

    function C(e) {
      this.message = e;
    }

    C.prototype = new Error(), C.prototype.name = "InvalidTokenError";

    function T(e, r) {
      (null == r || r > e.length) && (r = e.length);

      for (var t = 0, n = new Array(r); t < r; t++) n[t] = e[t];

      return n;
    }

    var P,
        N = function (e) {
      var r,
          t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
          n = t.cookieStore,
          o = t.req;

      try {
        if (n && n instanceof Function) return n().get(e);
        var a = o ? o.headers.cookie : !("undefined" == typeof window || null === (r = window.document) || void 0 === r || !r.createElement) && document.cookie;
        return (a ? a.split("; ").reduce(function (e, r) {
          var t,
              n,
              o = (t = r.split("="), n = 2, function (e) {
            if (Array.isArray(e)) return e;
          }(t) || function (e, r) {
            var t = null == e ? null : "undefined" != typeof Symbol && e[Symbol.iterator] || e["@@iterator"];

            if (null != t) {
              var n,
                  o,
                  a,
                  i,
                  l = [],
                  c = !0,
                  s = !1;

              try {
                if (a = (t = t.call(e)).next, 0 === r) {
                  if (Object(t) !== t) return;
                  c = !1;
                } else for (; !(c = (n = a.call(t)).done) && (l.push(n.value), l.length !== r); c = !0);
              } catch (e) {
                s = !0, o = e;
              } finally {
                try {
                  if (!c && null != t.return && (i = t.return(), Object(i) !== i)) return;
                } finally {
                  if (s) throw o;
                }
              }

              return l;
            }
          }(t, n) || function (e, r) {
            if (e) {
              if ("string" == typeof e) return T(e, r);
              var t = Object.prototype.toString.call(e).slice(8, -1);
              return "Object" === t && e.constructor && (t = e.constructor.name), "Map" === t || "Set" === t ? Array.from(e) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? T(e, r) : void 0;
            }
          }(t, n) || function () {
            throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
          }()),
              a = o[0],
              i = o[1];
          return e[a] = i, e;
        }, {}) : {})[e];
      } catch (e) {
        return "";
      }
    },
        L = "CVIdToken",
        M = function (e) {
      return e ? {
        email: null == e ? void 0 : e.email,
        name: null == e ? void 0 : e.name,
        user_id: null == e ? void 0 : e.user_id,
        given_name: null == e ? void 0 : e.given_name,
        family_name: null == e ? void 0 : e.family_name,
        sub: null == e ? void 0 : e.sub,
        is_new_3p: Boolean(null == e ? void 0 : e.is_user_new) && "false" !== e.is_user_new.toLowerCase()
      } : {};
    },
        V = function (e) {
      var r, t;
      return e ? {
        impersonating_user: e.impersonating_user,
        is_impersonating: null !== (r = "true" === (null === (t = e.is_impersonating) || void 0 === t ? void 0 : t.toLowerCase())) && void 0 !== r && r
      } : {};
    },
        H = function () {
      var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
          r = function (e) {
        var r = e.cookieStore,
            t = e.req,
            n = N(L, {
          cookieStore: r,
          req: t
        }) || "",
            o = function () {
          var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
              r = e.cookieStore,
              t = e.req,
              n = N("CVAccessToken", {
            req: t,
            cookieStore: r
          }) || "";

          if (n) {
            var o = "";

            try {
              var a;
              o = (null === (a = JSON.parse(n)) || void 0 === a ? void 0 : a.access_token) || n;
            } catch (e) {
              o = n;
            }

            return o;
          }

          return "";
        }({
          cookieStore: r,
          req: t
        });

        return n && o || o && !n ? {
          token: n ? L : o ? "CVAccessToken" : "MISSING",
          jwt: U(n || o),
          cvIdToken: n,
          cvAccessToken: o
        } : {
          token: "MISSING",
          jwt: {},
          cvIdToken: n,
          cvAccessToken: o
        };
      }({
        cookieStore: e.cookieStore,
        req: e.req
      }),
          t = r.token,
          n = r.jwt,
          o = r.cvIdToken,
          a = r.cvAccessToken;

      return o && a || a && !o ? {
        token: t,
        jwt: n,
        isValidToken: !!n && Object.keys(n).length > 0,
        isLoggedIn: !(null == n || !n.user_id),
        user: M(n),
        impersonation: V(n),
        cvIdToken: o,
        cvAccessToken: a
      } : {
        token: t,
        jwt: n,
        isValidToken: !1,
        isLoggedIn: !1,
        user: {},
        impersonation: {},
        cvIdToken: o,
        cvAccessToken: a
      };
    },
        U = function (e) {
      try {
        return e ? function (e) {
          try {
            return function (e, r) {
              if ("string" != typeof e) throw new C("Invalid token specified");
              var t = !0 === (r = r || {}).header ? 0 : 1;

              try {
                return JSON.parse(function (e) {
                  var r = e.replace(/-/g, "+").replace(/_/g, "/");

                  switch (r.length % 4) {
                    case 0:
                      break;

                    case 2:
                      r += "==";
                      break;

                    case 3:
                      r += "=";
                      break;

                    default:
                      throw "Illegal base64url string!";
                  }

                  try {
                    return function (e) {
                      return decodeURIComponent(E(e).replace(/(.)/g, function (e, r) {
                        var t = r.charCodeAt(0).toString(16).toUpperCase();
                        return t.length < 2 && (t = "0" + t), "%" + t;
                      }));
                    }(r);
                  } catch (e) {
                    return E(r);
                  }
                }(e.split(".")[t]));
              } catch (e) {
                throw new C("Invalid token specified: " + e.message);
              }
            }(e);
          } catch (e) {
            return console.error("Error decoding JWT:", e), {};
          }
        }(e) : {};
      } catch (e) {
        return {};
      }
    };

    function D() {
      return D = Object.assign ? Object.assign.bind() : function (e) {
        for (var r = 1; r < arguments.length; r++) {
          var t = arguments[r];

          for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        }

        return e;
      }, D.apply(this, arguments);
    }

    const q = function (e) {
      return v.createElement("svg", D({
        xmlns: "http://www.w3.org/2000/svg",
        width: 16,
        height: 16,
        fill: "none"
      }, e), P || (P = v.createElement("path", {
        fill: "#0D375E",
        d: "M3.3 1.654a4.27 4.27 0 0 1 4.659.929l.002.002.039.04.039-.04.002-.002a4.267 4.267 0 0 1 6.044 0c1.697 1.697 1.734 4.503-.276 6.55l-.004.005-5.334 5.334a.667.667 0 0 1-.943 0L2.191 9.134C.18 7.086.218 4.28 1.915 2.582A4.3 4.3 0 0 1 3.3 1.654m1.637 1.007a2.93 2.93 0 0 0-2.078.863h-.001c-1.13 1.13-1.265 3.096.282 4.674L8 13.058l4.86-4.86c1.547-1.578 1.41-3.544.282-4.673l-.001-.001a2.933 2.933 0 0 0-4.154-.001l-.002.001-.51.518a.667.667 0 0 1-.95 0l-.51-.518-.002-.001a2.93 2.93 0 0 0-2.076-.862"
      })));
    };

    function B(e) {
      var r,
          t,
          n,
          o,
          i = e.cookies,
          s = e.route,
          u = (null == i ? void 0 : i.PartnerVanityUrlName) || "notused",
          f = null == i ? void 0 : i.PartnerObject;
      if (f) try {
        o = JSON.parse(f);
      } catch (e) {}
      var d = H({
        cookieStore: function () {
          var e = new Map();

          for (var r in i) e.set(r, i[r]);

          return e;
        }
      }),
          v = (null == d ? void 0 : d.isLoggedIn) || !1,
          p = (null == d || null === (r = d.user) || void 0 === r ? void 0 : r.given_name) || "",
          y = (null == d || null === (t = d.user) || void 0 === t ? void 0 : t.family_name) || "";
      return (0, a.jsx)("nav", {
        "aria-label": "site-navigation",
        children: (0, a.jsxs)("div", {
          className: c["header-wrapper"],
          "aria-label": "site-navigation",
          children: [(0, a.jsx)(l, {
            partnerVanityUrlName: u,
            shouldHidePartnerHeaderBanner: null === (n = o) || void 0 === n ? void 0 : n.shouldHidePartnerHeaderBanner
          }), (0, a.jsxs)("div", {
            className: c.account,
            children: [v && (0, a.jsx)("div", {
              className: c["favorites-skeleton"],
              "data-testid": "favorites-placeholder",
              children: (0, a.jsx)(q, {})
            }), (0, a.jsx)(_, {
              isLoggedIn: v,
              first: p,
              last: y
            })]
          }), (0, a.jsx)("div", {
            className: c.break
          }), (0, a.jsx)(m, {
            className: c["nav-bar"],
            route: s
          })]
        })
      });
    }

    var J = function () {
      var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : "development";
      if ("undefined" == typeof window || !e) return null;
      var r,
          t,
          n = {
        dev: "fastly.zagforward.com",
        development: "fastly.zagforward.com",
        test: "fastly.carvanatech.com",
        prod: "fastly.carvana.io",
        production: "fastly.carvana.io"
      }[e],
          o = (r = new Date(), t = 15 * Math.round(r.getMinutes() / 15), "".concat(r.getDate()).concat(r.getHours()).concat(t));
      return "https://".concat("static", ".").concat(n).concat("/header-module/header/assets-manifest.json", "?v=").concat(o);
    };

    const R = {
      "core-header-ui": "E9Bg8PdufZVnZnm5zjPR"
    };

    function z(e, r) {
      (null == r || r > e.length) && (r = e.length);

      for (var t = 0, n = new Array(r); t < r; t++) n[t] = e[t];

      return n;
    }

    var F = function () {
      return document.cookie.split("; ").reduce(function (e, r) {
        var t,
            n = function (e) {
          if (Array.isArray(e)) return e;
        }(t = r.split("=")) || function (e) {
          if ("undefined" != typeof Symbol && null != e[Symbol.iterator] || null != e["@@iterator"]) return Array.from(e);
        }(t) || function (e, r) {
          if (e) {
            if ("string" == typeof e) return z(e, r);
            var t = Object.prototype.toString.call(e).slice(8, -1);
            return "Object" === t && e.constructor && (t = e.constructor.name), "Map" === t || "Set" === t ? Array.from(e) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? z(e, r) : void 0;
          }
        }(t) || function () {
          throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
        }(),
            o = n[0],
            a = n.slice(1);

        return e[o] = a.join("="), e;
      }, {});
    };

    function G(e) {
      return G = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
        return typeof e;
      } : function (e) {
        return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
      }, G(e);
    }

    function Q(e, r) {
      var t = Object.keys(e);

      if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        r && (n = n.filter(function (r) {
          return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, n);
      }

      return t;
    }

    function W(e) {
      for (var r = 1; r < arguments.length; r++) {
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? Q(Object(t), !0).forEach(function (r) {
          X(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : Q(Object(t)).forEach(function (r) {
          Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
      }

      return e;
    }

    function X(e, r, t) {
      return n = function (e, r) {
        if ("object" != G(e) || !e) return e;
        var t = e[Symbol.toPrimitive];

        if (void 0 !== t) {
          var n = t.call(e, "string");
          if ("object" != G(n)) return n;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }

        return String(e);
      }(r), (r = "symbol" == G(n) ? n : String(n)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : e[r] = t, e;
      var n;
    }

    function Z(e, r) {
      return function (e) {
        if (Array.isArray(e)) return e;
      }(e) || function (e, r) {
        var t = null == e ? null : "undefined" != typeof Symbol && e[Symbol.iterator] || e["@@iterator"];

        if (null != t) {
          var n,
              o,
              a,
              i,
              l = [],
              c = !0,
              s = !1;

          try {
            if (a = (t = t.call(e)).next, 0 === r) {
              if (Object(t) !== t) return;
              c = !1;
            } else for (; !(c = (n = a.call(t)).done) && (l.push(n.value), l.length !== r); c = !0);
          } catch (e) {
            s = !0, o = e;
          } finally {
            try {
              if (!c && null != t.return && (i = t.return(), Object(i) !== i)) return;
            } finally {
              if (s) throw o;
            }
          }

          return l;
        }
      }(e, r) || $(e, r) || function () {
        throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
      }();
    }

    function $(e, r) {
      if (e) {
        if ("string" == typeof e) return K(e, r);
        var t = Object.prototype.toString.call(e).slice(8, -1);
        return "Object" === t && e.constructor && (t = e.constructor.name), "Map" === t || "Set" === t ? Array.from(e) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? K(e, r) : void 0;
      }
    }

    function K(e, r) {
      (null == r || r > e.length) && (r = e.length);

      for (var t = 0, n = new Array(r); t < r; t++) n[t] = e[t];

      return n;
    }

    const Y = function (e) {
      if (void 0 === e) return {};
      if ("string" == typeof e) return e.split("; ").reduce(function (e, r) {
        var t = Z(r.split("="), 2),
            n = t[0],
            o = t[1];
        return W(W({}, e), {}, X({}, n, o));
      }, {});

      if (e instanceof Map) {
        var r,
            t = {},
            n = function (e, r) {
          var t = "undefined" != typeof Symbol && e[Symbol.iterator] || e["@@iterator"];

          if (!t) {
            if (Array.isArray(e) || (t = $(e))) {
              t && (e = t);

              var n = 0,
                  o = function () {};

              return {
                s: o,
                n: function () {
                  return n >= e.length ? {
                    done: !0
                  } : {
                    done: !1,
                    value: e[n++]
                  };
                },
                e: function (e) {
                  throw e;
                },
                f: o
              };
            }

            throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
          }

          var a,
              i = !0,
              l = !1;
          return {
            s: function () {
              t = t.call(e);
            },
            n: function () {
              var e = t.next();
              return i = e.done, e;
            },
            e: function (e) {
              l = !0, a = e;
            },
            f: function () {
              try {
                i || null == t.return || t.return();
              } finally {
                if (l) throw a;
              }
            }
          };
        }(e);

        try {
          for (n.s(); !(r = n.n()).done;) {
            var o = Z(r.value, 2),
                a = o[0],
                i = o[1];
            t[a] = i;
          }
        } catch (e) {
          n.e(e);
        } finally {
          n.f();
        }

        return t;
      }

      return function (e) {
        return Array.isArray(e) && e.every(function (e) {
          return "string" == typeof e.name && "string" == typeof e.value;
        });
      }(e) ? e.reduce(function (e, r) {
        return W(W({}, e), {}, X({}, r.name, r.value));
      }, {}) : e;
    };

    function ee(e, r) {
      (null == r || r > e.length) && (r = e.length);

      for (var t = 0, n = new Array(r); t < r; t++) n[t] = e[t];

      return n;
    }

    function re(e) {
      var r,
          t,
          n = e.cookies,
          o = e.route,
          i = Y(n),
          l = (r = (0, v.useState)(i), t = 2, function (e) {
        if (Array.isArray(e)) return e;
      }(r) || function (e, r) {
        var t = null == e ? null : "undefined" != typeof Symbol && e[Symbol.iterator] || e["@@iterator"];

        if (null != t) {
          var n,
              o,
              a,
              i,
              l = [],
              c = !0,
              s = !1;

          try {
            if (a = (t = t.call(e)).next, 0 === r) {
              if (Object(t) !== t) return;
              c = !1;
            } else for (; !(c = (n = a.call(t)).done) && (l.push(n.value), l.length !== r); c = !0);
          } catch (e) {
            s = !0, o = e;
          } finally {
            try {
              if (!c && null != t.return && (i = t.return(), Object(i) !== i)) return;
            } finally {
              if (s) throw o;
            }
          }

          return l;
        }
      }(r, t) || function (e, r) {
        if (e) {
          if ("string" == typeof e) return ee(e, r);
          var t = Object.prototype.toString.call(e).slice(8, -1);
          return "Object" === t && e.constructor && (t = e.constructor.name), "Map" === t || "Set" === t ? Array.from(e) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? ee(e, r) : void 0;
        }
      }(r, t) || function () {
        throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
      }()),
          c = l[0],
          s = l[1];
      (0, v.useEffect)(function () {
        if ("undefined" != typeof window && void 0 === n) {
          var e = F(),
              r = Y(e);
          s(r);
        }
      }, []);
      var u = "core-header-ui",
          f = 0 === (null == o ? void 0 : o.indexOf("/")) ? o : "/".concat(o);
      return (0, a.jsx)("div", {
        id: u,
        className: R[u],
        "data-testid": u,
        children: (0, a.jsx)(B, {
          cookies: c,
          route: f
        })
      });
    }

    const te = re;
  })(), module.exports = n;
})();